'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: none;\n'], ['\n  display: none;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _AttachButton = require('./AttachButton');

var _AttachButton2 = _interopRequireDefault(_AttachButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HiddenInput = _styledComponents2.default.input.withConfig({
  displayName: 'AttachmentPickerButton__HiddenInput'
})(_templateObject);

var AttachmentPickerButton = function (_React$PureComponent) {
  _inherits(AttachmentPickerButton, _React$PureComponent);

  function AttachmentPickerButton(props) {
    _classCallCheck(this, AttachmentPickerButton);

    var _this = _possibleConstructorReturn(this, (AttachmentPickerButton.__proto__ || Object.getPrototypeOf(AttachmentPickerButton)).call(this, props));

    _this.inputRefCallback = function (ref) {
      _this.inputRef = ref;
    };

    _this.findInputNode = function () {
      if (!_this.inputRef) {
        return null;
      }

      var inputNode = _reactDom2.default.findDOMNode(_this.inputRef);

      return inputNode;
    };

    _this.clearInputNode = function () {
      var inputNode = _this.findInputNode();

      if (inputNode) {
        inputNode.value = '';
      }
    };

    _this.handlePickerClick = function (e) {
      var inputNode = _this.findInputNode();

      if (inputNode) {
        inputNode.click();
      }

      _this.props.onClick(e);
    };

    _this.onInputChange = function (_ref) {
      var files = _ref.target.files;

      _this.props.onSelectFiles({ files: files });

      _this.clearInputNode();
    };

    _this.renderMaxFileSizeTooltip = function () {
      if (_this.props.mobile) {
        return undefined;
      }

      return _react2.default.createElement(_FormattedMessage2.default, {
        message: 'cvInternalComponentsAttachments.fileSizeLimit',
        options: {
          size: _I18n2.default.formatSize(_this.props.maxAttachmentFileSize)
        }
      });
    };

    _this.inputRef = null;
    return _this;
  }

  _createClass(AttachmentPickerButton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_AttachButton2.default, {
          color: this.props.color,
          disabled: this.props.disabled,
          mobile: this.props.mobile,
          onClick: this.handlePickerClick,
          tooltip: this.renderMaxFileSizeTooltip()
        }),
        _react2.default.createElement(HiddenInput, {
          accept: this.props.accept.join(','),
          'data-selenium-test': 'visitor-attachment-file-input',
          disabled: this.props.disabled,
          innerRef: this.inputRefCallback,
          type: 'file',
          multiple: this.props.allowMultiple,
          onChange: this.onInputChange
        })
      );
    }
  }]);

  return AttachmentPickerButton;
}(_react2.default.PureComponent);

AttachmentPickerButton.propTypes = {
  accept: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
  allowMultiple: _react.PropTypes.bool.isRequired,
  color: _react.PropTypes.string.isRequired,
  disabled: _react.PropTypes.bool,
  maxAttachmentFileSize: _react.PropTypes.number.isRequired,
  mobile: _react.PropTypes.bool,
  onClick: _react.PropTypes.func,
  onSelectFiles: _react.PropTypes.func.isRequired
};

AttachmentPickerButton.defaultProps = {
  accept: [],
  allowMultiple: false,
  onClick: function onClick() {}
};

exports.default = AttachmentPickerButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/attachments/AttachmentPickerButton.js
// module id = 1165
// module chunks = 2 3